import type { ButtonHTMLAttributes, AnchorHTMLAttributes, ReactNode } from "react";
import { Link } from "react-router-dom";

type Variant = "default" | "primary" | "hi" | "ghost";

interface CommonProps {
  variant?: Variant;
  /** large field tap target (>=56px) */
  lg?: boolean;
  block?: boolean;
  icon?: ReactNode;
  children?: ReactNode;
}

const cls = (variant: Variant, lg?: boolean, block?: boolean, extra?: string) =>
  [
    "btn",
    variant === "primary" && "btn--primary",
    variant === "hi" && "btn--hi",
    variant === "ghost" && "btn--ghost",
    lg && "btn--lg",
    block && "btn--block",
    extra,
  ]
    .filter(Boolean)
    .join(" ");

export function Btn({
  variant = "default",
  lg,
  block,
  icon,
  children,
  className,
  ...rest
}: CommonProps & ButtonHTMLAttributes<HTMLButtonElement>) {
  return (
    <button className={cls(variant, lg, block, className)} {...rest}>
      {icon ? <span className="ico" aria-hidden="true">{icon}</span> : null}
      {children}
    </button>
  );
}

/** Router-aware button-styled link. */
export function BtnLink({
  to,
  variant = "default",
  lg,
  block,
  icon,
  children,
  className,
  state,
  ...rest
}: CommonProps & { to: string; state?: unknown } & AnchorHTMLAttributes<HTMLAnchorElement>) {
  return (
    <Link to={to} state={state} className={cls(variant, lg, block, className)} {...rest}>
      {icon ? <span className="ico" aria-hidden="true">{icon}</span> : null}
      {children}
    </Link>
  );
}
